const data = [
    {
        "评审姓名": "徐毅",
        "介绍": "评审委员会主席",
        "角色": "Timothy Xu",
        "组": "主席",
        "url": "http://img01.cmicawards.org.cn/cover/评委_徐毅.jpg"
    },
    {
        "评审姓名": "李宗盛",
        "介绍": "评审团首席顾问",
        "角色": "Jonathan Lee",
        "组": "首席顾问",
        "url": "http://img01.cmicawards.org.cn/cover/评委_李宗盛.jpg"
    },
    {
        "评审姓名": "金少刚",
        "介绍": "著名录音混音及现场演出录音工程师、金总文工团舞美制作中心副主任、北京奥运会开幕式的音响总工程师、浙江卫视《中国好声音》音响总监",
        "角色": "评审",
        "组": "金少刚",
        "url": "http://img01.cmicawards.org.cn/cover/评委_金少刚.jpg",
        "组员": [
            {
                "评审姓名": "李军",
                "介绍": "录音混音工程师、华语金曲奖最佳录音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "陈珞",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "章寅（老虎）",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "瞿然",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "王磊",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "周天澈",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "张军军",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "赵靖",
                "介绍": "录音混音工程师、北京BIG.J Studio创始人",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "时俊峰",
                "介绍": "录音混音工程师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "林梦洋",
                "介绍": "混音师",
                "角色": "顾问",
                "组": "金少刚"
            }
        ]
    },
    {
        "评审姓名": "沈黎晖",
        "介绍": "摩登天空创始人、草莓音乐节创始人、音乐人",
        "角色": "评审",
        "组": "沈黎晖",
        "url": "http://img01.cmicawards.org.cn/cover/评委_沈黎晖.jpg",
        "组员": [
            {
                "评审姓名": "周小川",
                "介绍": "星外星音乐总裁",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "丁武",
                "介绍": "歌手、画家",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "李岱",
                "介绍": "热波传媒总裁",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "臧鸿飞",
                "介绍": "摇滚、电子、流行、爵士等多种风格的音乐家兼制作人",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "郝舫",
                "介绍": "著名作家、乐评人、文化名人、电视节目制片人、菠萝BOLO CEO",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "李宏杰",
                "介绍": "MTA天漠音乐节创始人、张北音乐节创办人",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "袁涛",
                "介绍": "心喜文化创始人CEO",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "张有待",
                "介绍": "主持人、最具影响力的中国DJ ",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "陈健添",
                "介绍": "乐坛传奇伯乐、现任摇滚优先厂牌老板",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "杨锦聪",
                "介绍": "独立制片唱片公司“风潮有声出版有限公司”创办人、总经理",
                "角色": "顾问",
                "组": "沈黎晖"
            }
        ]
    },
    {
        "评审姓名": "金培达",
        "介绍": "资深作曲、监制、电影音乐人",
        "角色": "评审",
        "组": "金培达",
        "url": "http://img01.cmicawards.org.cn/cover/评委_金培达.jpg",
        "组员": [
            {
                "评审姓名": "陈少琪",
                "介绍": "资深作人及创作人、香港作曲家及作词家协会理事",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "崔恕",
                "介绍": "著名作词人",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "科尔沁夫",
                "介绍": "词曲创作家、乐评人",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "李念和",
                "介绍": "词曲制作人、台湾MUST音乐著作权协会董事长",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "小柯",
                "介绍": "音乐戏剧创作人",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "老狼",
                "介绍": "歌手、校园民谣代表人物",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "陈辉阳",
                "介绍": "作曲/监制",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "梁咏琪",
                "介绍": "著名歌手、演员",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "方文山",
                "介绍": "著名词作家 ",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "周笔畅",
                "介绍": "著名歌手、演员、词曲人",
                "角色": "顾问",
                "组": "金培达"
            }
        ]
    },
    {
        "评审姓名": "贾敏恕",
        "介绍": "街声股份有限公司总裁、简单生活节共同创办人",
        "角色": "评审",
        "组": "贾敏恕",
        "url": "http://img01.cmicawards.org.cn/cover/评委_贾敏恕.jpg",
        "组员": [
            {
                "评审姓名": "钟兴民",
                "介绍": "资深制作人、编曲家",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "马正远",
                "介绍": "潮流音乐推动者、88上昇创办人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "姚中仁",
                "介绍": "嘻哈音乐先锋",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "张楚",
                "介绍": "词曲作家、资深原创音乐人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "高旗",
                "介绍": "词曲作家、资深原创音乐人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "李皖",
                "介绍": "文化人、资深乐评",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "王昕",
                "介绍": "文化人、资深乐评",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "詹华",
                "介绍": "音乐行业资深企划人、经理人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "张帆",
                "介绍": "原创音乐推动者、迷笛创办人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "安栋",
                "介绍": "资深制作人、编曲家",
                "角色": "顾问",
                "组": "贾敏恕"
            }
        ]
    },
    {
        "评审姓名": "宋晓辉",
        "介绍": "资深唱片设计师、摄影师，长期从事音乐视觉工作",
        "角色": "评审",
        "组": "宋晓辉",
        "url": "http://img01.cmicawards.org.cn/cover/评委_宋晓辉.jpg",
        "组员": [
            {
                "评审姓名": "唐大年",
                "介绍": "著名导演、编剧",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "颜伯骏",
                "介绍": "台湾著名设计师",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "梁博",
                "介绍": "音乐唱作人",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "尤洋",
                "介绍": "艺术评论、策展人，尤伦斯当代艺术中心副馆长",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "赵宏韬",
                "介绍": "平面设计师，PMDesign主理人",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "孔阳",
                "介绍": "独立设计师、音乐制作人，旅行团乐队主唱",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "郑楠",
                "介绍": "著名编曲、作曲、制作人",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "丁世光",
                "介绍": "歌手，制作人",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "曾晓",
                "介绍": "MV导演、新锐摄影师",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "李嘉木",
                "介绍": "摩登天空设计总监，MVM设计厂牌主理",
                "角色": "顾问",
                "组": "宋晓辉"
            }
        ]
    },
    {
        "评审姓名": "谭伊哲",
        "介绍": "全能型音乐家、音乐总监、编曲家、著名音乐制作人、作曲家、集合多种乐器演奏于一身、被誉为华语歌坛“音乐魔法师”",
        "角色": "评审",
        "组": "谭伊哲",
        "url": "http://img01.cmicawards.org.cn/cover/评委_谭伊哲.jpg",
        "组员": [
            {
                "评审姓名": "朱敬然",
                "介绍": "著名音乐人、现任种子音乐集团音乐总监/新意思音乐总经理",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "刘雨潼",
                "介绍": "著名歌手、词曲创作人、音乐制作人",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "Daryl K.",
                "介绍": "音乐制作人、音乐总监、作曲",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "韩星洲",
                "介绍": "音乐制作人、S.E.J.P音乐厂牌CEO",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "李晓东",
                "介绍": "流行男歌手",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "黃竣琮",
                "介绍": "音乐制作人、乐队总监",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "霍尊",
                "介绍": "流行男歌手",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "殷文琦",
                "介绍": "著名作曲家、音乐制作人",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "纪丹迪（纪敏佳）",
                "介绍": "流行女歌手",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "韩罗贤",
                "介绍": "台湾知名音乐人",
                "角色": "顾问",
                "组": "谭伊哲"
            }
        ]
    },
    {
        "评审姓名": "吴彤",
        "介绍": "跨界音乐家、二次获得格莱美奖",
        "角色": "评审",
        "组": "吴彤",
        "url": "http://img01.cmicawards.org.cn/cover/评委_吴彤.jpg",
        "组员": [
            {
                "评审姓名": "赵麟",
                "介绍": "当代作曲家、著名音乐人",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "刘雪枫",
                "介绍": "音乐评论家，古典音乐推广者，文化学者，研究员，《雪枫音乐会》主讲人，“音乐之友”创始人",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "刘沙",
                "介绍": "中央名族乐团指挥",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "叶聪",
                "介绍": "新加坡华乐团音乐总监、著名指挥家",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "王亮",
                "介绍": "纽约爱乐双簧管首席",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "李心草",
                "介绍": "国交指挥",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "赵季平",
                "介绍": "著名作曲家",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "李晖",
                "介绍": "中央音乐学院琵琶专业博导",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "刘麟",
                "介绍": "吉他演奏家",
                "角色": "顾问",
                "组": "吴彤"
            },
            {
                "评审姓名": "乔建中",
                "介绍": "音乐学者，原中国音乐研究所所长",
                "角色": "顾问",
                "组": "吴彤"
            }
        ]
    },
    {
        "评审姓名": "秦四风",
        "介绍": "作曲家，演奏家，制作人及导演，三项金曲奖获得者，唱工委最佳混音奖获得者",
        "角色": "评审",
        "组": "秦四风",
        "url": "http://img01.cmicawards.org.cn/cover/评委_秦四风.jpg",
        "组员": [
            {
                "评审姓名": "黄勇",
                "介绍": "中国爵士乐推广者，爵士乐学会秘书长，北京九门爵士节创始人",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "任宇清",
                "介绍": "爵士中国推行者，JZ MUSIC创始，贝斯演奏家",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "Larry Williams",
                "介绍": "格莱美提名制作人，作曲家，编曲家，多种乐器演奏家",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "Scott Henderson",
                "介绍": "美国融合爵士吉他演奏家",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "谷峰",
                "介绍": "国家一级演员，中国音乐家协会会员，中国爵士乐学会副会长、中国金唱片奖获得者，CMA最佳爵士演唱获得者",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "崔鸿根",
                "介绍": "中央音乐学院爵士钢琴专业教授",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "孙大峰",
                "介绍": "吉林艺术学院流行音乐学院院长",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "晁晨",
                "介绍": "电影导演",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "丁薇",
                "介绍": "著名音乐人，歌手，影视作曲家",
                "角色": "顾问",
                "组": "秦四风"
            },
            {
                "评审姓名": "Goh Hotoda",
                "介绍": "日本音乐制作人，混音工程师、两次格莱美奖获得者",
                "角色": "顾问",
                "组": "秦四风"
            }
        ]
    },
    {
        "评审姓名": "邓柯",
        "介绍": "乐评人",
        "角色": "评审",
        "组": "邓柯",
        "url": "http://img01.cmicawards.org.cn/cover/评委_邓柯.jpg",
        "组员": [
            {
                "评审姓名": "滕兴瑞（滕少）",
                "介绍": "音乐制作人，词曲创作人。SNH48音乐总监、公演制作人，10年偶像制造经验",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "祁又一",
                "介绍": "乐评人、作家。历任《精品购物指南》文娱部主任编辑，新浪摇滚频道主编，中国摇滚榜制片人，《Q》音乐杂志主编等。老舍文学奖得主",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "王铉",
                "介绍": "中国传媒大学音乐与录音艺术学院音乐系主任",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "汤佩弦",
                "介绍": "音乐策划人、音乐制作人，牛班联合创始人",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "朱金泰",
                "介绍": "音乐制作人，有沐音乐主理人",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "金承志",
                "介绍": "彩虹室内合唱团音乐总监",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "王皓",
                "介绍": "虾米音乐创始人&CEO",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "董颖达",
                "介绍": "作曲家，知名影视音乐制作人",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "洪涛",
                "介绍": "《我是歌手》总导演",
                "角色": "顾问",
                "组": "邓柯"
            },
            {
                "评审姓名": "相征",
                "介绍": "大内密谈主理人",
                "角色": "顾问",
                "组": "邓柯"
            }
        ]
    }
]

export default data